<!-- <app-auth-navbar></app-auth-navbar> -->
<div class="hero">
    <div class="container w-container d-flex flex-wrap">

        <div class="col-12 col-md-6 d-flex flex-column justify-content-center my-2">
            <span class="mx-auto py-1 px-3" style="background-color: #2371D3;color:white">
                Find a location near you
            </span>
            <span class="w-100 d-flex justify-content-around align-items-center my-3 rounded py-2 px-3" style="background-color: #a1c181;color:white">
                <input type="text" class="col-10 p-2 rounded border-0" [(ngModel)]="postalCode">
                <i class="fas fa-search p-2 cursor-pointer" (click)="getLocationByPostal()"></i>
            </span>
            <div class="w-100 text-center my-2 text-danger" *ngIf="show">
                No locations found
            </div>
            <div class="w-100 d-flex flex-wrap py-3 align-items-center">
                <div class="col-12 col-md-6 text-center"><img src="../../assets/images/p1.png" alt="" class="w-75"></div>
                <div class="col-12 col-md-6 text-center"><img src="../../assets/images/p3.png" alt="" class="w-75"></div>
            </div>
            
            <div class="w-100 d-flex flex-wrap py-3 align-items-center">
                <div class="col-12 col-md-6 text-center d-flex flex-wrap justify-content-center h-100">
                    <img src="../../assets/images/p2.png" alt="" class="w-75">
                    <img src="../../assets/images/p5.png" alt="" class="w-75">
                </div>
                <div class="col-12 col-md-6 text-center"><img src="../../assets/images/p4.jpg" alt="" class="w-75"></div>
            </div>
            <div class="w-100 d-flex flex-wrap py-3 align-items-center">
                <div class="col-12 col-md-6 text-center"><img src="../../assets/images/p7.png" alt="" class="w-75"></div>
                <div class="col-12 col-md-6 text-center"><img src="../../assets/images/p6.png" alt="" class="w-75"></div>
            </div>
        </div>
        <div class="col-12 col-md-6 d-flex flex-wrap my-2 justify-content-center">
            <div class="col-12 p-1 my-2 d-flex">
                <!-- <div class="w-100 my-1 cursor-pointer text-left p-1" *ngFor="let location of locations" (click)="assignCoordinates(location.latitude, location.longitude, location)" [ngClass]="{'bg-pale-blue': location==selectedLocation}">
                    <h4>{{location.location_name}}</h4>
                    <h6>    
                        {{location.address1}}<br />
                        {{location.town}}, {{location.prov_state}}<br />
                        {{location.postal_code}}
                    </h6>
                </div> -->
                <span class="py-1 pl-0 pr-2 cursor-pointer text-center" (click)="prevLocations()">
                    <i class="fas fa-arrow-circle-left"></i><br />
                    Previous
                </span>
                <select name="" id="" (change)="assignCoordinates($event.target.value)" class="w-100">
                    <option [value]="location | json" *ngFor="let location of locations">
                        <h4>{{location.location_name}}</h4>
                        <h6>    
                            {{location.address1}}<br />
                            {{location.town}}, {{location.prov_state}}<br />
                            {{location.postal_code}}
                        </h6>
                    </option>
                </select>
                <span class="py-1 pl-2 pr-0 cursor-pointer text-center" (click)="nextLocations()">
                    <i class="fas fa-arrow-circle-right"></i><br />
                    Next
                </span>
                
            </div>
            <div class="col-12 p-0 m-0" style="height: 500px;" *ngIf="locations.length>0">
                <agm-map [latitude]="lat" [longitude]="lng">
                    <agm-marker 
                        *ngFor="let m of markers; let i = index"
                        [latitude]="m.lat"
                        [longitude]="m.lng"
                        [markerDraggable]="m.draggable"
                        (markerClick)="clickedMarker(infowindow)">
                        
                        <agm-info-window #infowindow>
                            <strong>{{m.title}}</strong>
                        </agm-info-window>
                        
                    </agm-marker>
                </agm-map>
            </div>
            <div class="col-12 p-0 m-0" style="height: 500px;" *ngIf="locations.length==0">
                <agm-map [latitude]="lat" [longitude]="lng">
                </agm-map>
            </div>
            <!-- <div class="col-12 d-flex justify-content-around p-1">
                <button class="btn btn-primary">
                    Previous
                </button>
                <button class="btn btn-primary">
                    Next
                </button>
            </div> -->
        </div>
        <span class="text-danger w-100 text-center">Only Bill Pay service is accepted at the Canada Post Locations.</span>
    </div>

</div>
<!-- <app-home-footer></app-home-footer> -->
